import { B1, H2, T1, BackgroundIcon } from '@nile/components';
import Help from '@nile/home/public/svg/help_icon.svg';
import SuperTip from '@nile/home/public/svg/SuperTipPop.svg';
import React from 'react';
import { Tooltip } from 'react-clone-tippy';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

const SrcInfoContainer = styled.div`
  display: flex;
  background: #ffffff;
  margin: 20px 40px;

  .userInfoIcon {
    font-size: 50px;
    margin: 0px 15px 15px 15px;
  }
`;

const ModalContent = styled.div`
  padding: 4%;
  height: 100vh;
  width: calc(100vw - 60px);
  background: #ffffff;
  overflow-y: auto;
`;

const Iconwrapper = styled.div`
  .icon-init {
    opacity: 0.5;
  }
  #icon-hover:hover {
    .hover-function {
      opacity: 1;
      // background-color: red;
    }
  }
  .count-bulb {
    background: #ececec;
    border-radius: 5px;
    padding: 0px 6px;
    font-size: 10px;
  }
`;

const CustomHeading = styled.div`
  font-size: 20px;
  margin: 14px 0px;
`;

const reactSelectInlineError = (error) => {
  return (
    <div className="Polaris-Labelled__Error">
      <div className="Polaris-InlineError">
        <div className="Polaris-InlineError__Icon">
          <span className="Polaris-Icon">
            <svg
              viewBox="0 0 20 20"
              className="Polaris-Icon__Svg"
              focusable="false"
              aria-hidden="true"
            >
              <path
                d="M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-8h2V6H9v4zm0 4h2v-2H9v2z"
                fillRule="evenodd"
              ></path>
            </svg>
          </span>
        </div>
        {error}
      </div>
    </div>
  );
};

const reactSelectErrorStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#fbeae5',
    borderColor: '#bf0711',
    // overwrittes hover style
    '&:hover': {
      borderColor: '#bf0711'
    }
  })
};

const MenuStyle = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: 999999
  }),
  control: (styles) => ({
    ...styles,
    zIndex: 99,
    backgroundColor: 'white',
    border: 'none',
    borderRadius: 0,
    borderBottom: '1px solid #F4F5F7'
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? data.color
        : isFocused
        ? data.color
        : null,
      color: isDisabled
        ? '#ccc'
        : isSelected
        ? 0
          ? 'gray'
          : 'black'
        : data.color,
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active']
      }
    };
  },
  indicatorSeparator: (styles) => ({
    ...styles,
    backgroundColor: 'transparent'
  })
};

/* temp fix, will  customise on react select style */
const SelectContainer = styled.div`
  .Polaris-Avatar {
    padding: 0px 12px !important;
  }

  .container {
    margin: 0px 10px;
    width: 100%;
  }

  .container div:first-child {
    border: none;
  }

  .container > div {
    border-bottom: 1px solid #e5e5e5 !important;
  }
`;

const HeaderTagIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  background: ${(props) => props.background || 'gray'};
  margin-right: 12px;
`;

function HeaderTag(props) {
  const { isBgStrip, isNewLayout, noMargin, iconConfig, type = 'H2' } = props;
  if (isNewLayout) {
    return (
      <div
        className={noMargin ? '' : 'lh-30 mb20'}
        style={{ fontSize: type === 'H2' ? '20px' : '16px' }}
      >
        <div className="fx flex-align-center">
          {iconConfig && (
            <HeaderTagIcon background={iconConfig.background}>
              <BackgroundIcon
                url={`url(${envConfig.imageRoot}svg/${iconConfig.icon})`}
                color={iconConfig?.color || '#fff'}
              />
            </HeaderTagIcon>
          )}
          <T1>
            <B1>{props.title}</B1>
          </T1>
        </div>
      </div>
    );
  }
  if (isBgStrip) {
    let baseClasses = 'flex header-tag';
    const classes = noMargin ? baseClasses : `${baseClasses} mb10`;
    return (
      <div className={classes}>
        <div className="CardHeader">{props.title}</div>
        <div className="header-triangle"></div>
      </div>
    );
  }
  return <div className="CardHeaderNormal">{props.title}</div>;
}
// console.log('propsssss', props);
function TabContent(props) {
  return (
    <Iconwrapper>
      <div id="icon-hover">
        <div className="flex center tab-content-wrap" id={props?.content}>
          {props.icon && (
            <div className="mr8 tab-icon hover-function icon-init">
              {props.icon}
            </div>
          )}
          <div className="flex center tab-content">{props.content}</div>
          {props.count >= 0 && (
            <div className="count-bulb ml8">{props.count}</div>
          )}
        </div>
      </div>
    </Iconwrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  background-color: #ffffff;
  min-width: 100px;
  margin: 21px 29px;
  border-radius: 10px;
  box-shadow: 0px 2.32836px 25.6119px rgba(0, 0, 0, 0.0531305);

  .svg {
    position: absolute;
    top: -21px;
    left: -25px;
  }

  .heading {
    font-weight: 500;
    position: absolute;
    font-size: 16px;
    left: 30px;
    top: 10px;
  }

  .contentDiv {
    padding: ${(props) =>
      props.noHeader ? '26px 35px 26px 27px' : '46px 35px 26px 27px'};
    text-align: justify;
  }
`;

const Content = styled.div`
  margin-top: 15px;
`;

function SuperPop(props) {
  const {
    content,
    position,
    className,
    holder,
    trigger,
    header = 'SuperTip',
    noHeader = false,
    iconSize = 'md'
  } = props;

  const Element = () => {
    return (
      <Wrapper noHeader={noHeader || !header}>
        {!noHeader && header && <div className="heading">{header}</div>}
        <div className="contentDiv">{content}</div>
      </Wrapper>
    );
  };

  return (
    <div style={{ cursor: 'pointer' }}>
      <Tooltip
        title="SuperPop"
        trigger={trigger || 'click'}
        position={position}
        html={<Element />}
        className={className}
        duration={250}
        theme="light"
        inertia
        distance={0}
      >
        {holder || (
          <SVGIcon
            name="HelpIcon"
            size={iconSize}
            color="var(--sops-black-to-black)"
          />
        )}
      </Tooltip>
    </div>
  );
}

const mentionsContainerStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 20,
    fontWeight: 700
  },

  '&multiLine': {
    control: {
      minHeight: 400
    },
    highlighter: {
      padding: 1,
      border: '2px inset transparent'
    },
    input: {
      padding: 4,
      border: '2px inset transparent',
      fontSize: 20,
      fontWeight: 700,
      borderRadius: 5
    }
  },

  '&singleLine': {
    display: 'inline-block',
    width: '100%',
    padding: '10px 0',

    highlighter: {
      padding: 1,
      border: '2px inset transparent'
    },
    input: {
      padding: 1,
      border: '2px inset transparent',
      fontSize: 20,
      fontWeight: 500
    }
  },

  suggestions: {
    zIndex: 2,
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
      maxHeight: 300,
      overflow: 'auto'
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#f1f1f1'
      }
    }
  }
};

const mentionsItemStyle = {
  backgroundColor: '#f1f1f1'
};

const TableContainer = styled.div`
  height: ${(props) => (props.fitContentHeight ? 'auto' : '100%')};
  .table {
    min-width: 400px !important;
  }

  .columnHeader {
    flex: none !important;
  }

  .tbody {
    display: inline-block;
    overflow: auto;

    .tr {
      min-height: 42px;
    }

    padding-top: 12px;
  }

  .tr .td,
  .inblock {
    padding-left: 4px;
  }

  .unFreezeContent {
    width: 99%;
    overflow: auto;
    white-space: nowrap;
    position: relative;
    // padding-left: 20px;
  }
  .unFreezeContent:hover {
    overflow: auto;
  }
  .cell {
    font-weight: ${(props) => (props.notBold ? '400 !important' : '')};
  }
`;

//CardPage which includes table inside it uses these properties
const cardTable = {
  noMargin: '0 !important',
  noContentPadding: '0',
  borderBottom: 'none'
};

/**
 * We need to Wrap the page component inside this wrapper to have a card page layout.
 */
const CardPage = styled.div`
  .Polaris-Page {
    flex-grow: 1;
    padding: 0 !important;
    background: #fff !important;
    border-radius: 10px;
    box-shadow: ${(props) => props.boxShadow && props.boxShadow} !important;
    height: ${(props) =>
      props.fullHeight
        ? '100%'
        : `calc(100vh - ${props.height ? props.height : '258px'}) !important`};
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '1400px')};
  }
  .Polaris-Page-Header {
    border-bottom: ${(props) =>
      props.tableContent ? cardTable.borderBottom : '1px solid #ececec'};
    padding: ${(props) =>
      props.headerPadding ? props.headerPadding : '20px 40px'} !important;
    h1 {
      font-weight: 700 !important;
    }
    .Polaris-Page-Header__MainContent {
      height: ${(props) =>
        props.headerHeight ? props.headerHeight : 'initial'};
    }
    .Polaris-Page-Header__PrimaryActionWrapper,
    .Superops-Page-Header__PrimaryActionWrapper {
      align-self: flex-start;
    }
    .value_selector__placeholder {
      font-size: 14px !important;
      font-weight: 400 !important;
    }
  }
  .Polaris-Page__Content {
    height: calc(
      100% - ${(props) => (props.contentHeight ? props.contentHeight : '120px')}
    );
    padding: ${(props) =>
      props.noContentPadding
        ? '0'
        : props.tableContent
        ? cardTable.noContentPadding
        : props.contentPadding
        ? props.contentPadding
        : '0 25px'};
    margin: ${(props) =>
      props.noMargin
        ? '0 !important'
        : props.tableContent
        ? cardTable.noMargin
        : ''};
    overflow: hidden;
  }
  .Polaris-Page__Content:hover {
    overflow: auto;
  }

  // TODO GA cleanup
  .Polaris-Page__Content > div:first-child {
    padding-bottom: 0;
  }

  //TODO refactor
  .Superops-Page {
    height: ${(props) =>
      props.fullHeight
        ? '100%'
        : `calc(100vh - ${props.height ? props.height : '258px'}) !important`};
  }
`;

const CascadeCard = styled.div.attrs({
  className: 'full-height'
})`
  .cascadeContainer {
    overflow: auto;
  }

  .cascade-list {
    height: calc(100% - 50px);
  }
  .cascadeContainer:first-child {
    background: var(--sops-cascade-first-child-container-bg) !important;
    border-radius: 12px;
    border-right: 1px solid #ffffff;
    min-width: 250px;
    max-width: 350px;
    width: 30%;
  }

  .cascadeContainer:last-child {
    border-radius: 0px;
    position: relative;
    padding: 0;
    padding-left: 20px;
    width: 75%;
  }

  .resource-item-wrapper {
    &.Superops-ResourceItem--selected {
      svg {
        color: white;
      }
    }

    &:hover {
      background: var(--sops-item-surface-hovered);
      &.Superops-ResourceItem--selected .Superops-ResourceItem {
        background: var(--sops-surface-RI-selected) !important;
      }
    }
  }
`;

/**
 * Wrap this for create/edit page in Admin so that each section is split by 50px gap
 */

const AdminDetailsWrapper = styled.div`
  gap: 40px;
  display: grid;
`;

/**
 * Wrapper to remove bottom border in hover and active state in addtion to NoBorder variant
 */
const NoBorderWrapper = styled.div`
  input {
    border-bottom: none !important;
  }
`;

/**
 * Wrap using this for additional info section in details page header. Like site, client, owner etc
 */

const AdditionalInfoWrap = styled.div.attrs({
  className: 'flex'
})`
  gap: 40px;
  // TODO GA cleanup
  // Avatar styles noted as variations in document.
  .Polaris-Avatar--sizeSmall {
    width: 20px;
    min-width: 20px;
  }
`;

/**
 * This is a splitter which is used as a seperator between two texts.
 */
const Splitter = styled.div.attrs({
  className: 'flex self-center'
})`
  border-right: 1px solid ${(props) => props.color || '#000'};
  height: 20px;
`;

/**
 * Use this component for simple header and content rendering.
 * Header will be bold and the content will be placed 15px helow the header
 */
const CardContent = (props) => {
  return (
    <div>
      <B1 className={props.classNames || ''}>{props.header}</B1>
      <Content>{props.content}</Content>
    </div>
  );
};

/**
 * Use this component to wrap the inline edit cells in a table
 */

const InlineEditTableWrapper = styled.div`
  height: 80%;
  .editable-cell {
    height: 100% !important;
  }
  .inline-edit--form {
    height: 100%;
  }
  .inline-edit {
    height: 100%;
  }
  .inline-edit--readview {
    height: 100%;
  }
  .api-loader {
    align-self: center;
  }
  .site-custom-class {
    transform: translateY(-6px);
  }
`;

const PrimaryHeader = styled.div`
  .Polaris-TextField__Input {
    line-height: 40px !important;
    font-size: 24px !important;
  }
  .Polaris-TextField__Backdrop {
    border: none !important;
  }
`;

const SecondaryHeader = styled.div`
  .Polaris-TextField__Backdrop {
    border: none !important;
  }
`;

const Suffix = styled.div`
  border-radius: 10px 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  width: ${(props) => props.width || '30px'};
`;

const StatusTag = styled.div.attrs({
  className: 'flex center uppercase f-12'
})`
  background: ${({ statusObject }) => statusObject?.color || 'transparent'};
  border-radius: 5px;
  height: 21px;
  font-weight: 500;
  padding: 0 8px;
  color: ${({ statusObject }) => statusObject?.fontColor || '#000000'};
`;

/**
 * Override quill editor styles. This is used across notification templates
 */
const TextEditorContainer = styled.div.attrs({
  className: 'bgwhite flex'
})`
  border: none;
  #quill-rt-editor {
    display: flex;
    flex-direction: column-reverse;
    height: 100%;
    .quill {
      min-height: 400px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
        }
      }
    }
    .ql-toolbar {
      border: none;
    }
  }
`;

export {
  SrcInfoContainer,
  ModalContent,
  CustomHeading,
  MenuStyle,
  SelectContainer,
  HeaderTag,
  TabContent,
  reactSelectErrorStyles,
  reactSelectInlineError,
  mentionsContainerStyle,
  mentionsItemStyle,
  TableContainer,
  CardPage,
  SuperPop,
  CascadeCard,
  AdminDetailsWrapper,
  AdditionalInfoWrap,
  Splitter,
  CardContent,
  InlineEditTableWrapper,
  PrimaryHeader,
  SecondaryHeader,
  Suffix,
  StatusTag,
  TextEditorContainer,
  NoBorderWrapper
};
